import type { PropsWithChildren, ComponentProps, ElementType } from 'react';

type ConditionalComponentProps<E extends ElementType = ElementType> = {
  condition: boolean;
  as?: E;
} & PropsWithChildren;

type Props<E extends ElementType> = Omit<ComponentProps<E>, keyof ConditionalComponentProps> &
  ConditionalComponentProps<E>;

/**
 * The default tag to render
 */
const defaultTag = 'div' as const;

/**
 * Wrap children in a component conditionally
 */
export function ConditionalComponent<E extends ElementType = typeof defaultTag>({
  condition,
  children,
  as,
  ...rest
}: Props<E>) {
  const Wrapper = as || defaultTag;

  return condition ? <Wrapper {...rest}>{children}</Wrapper> : children;
}
